module.exports = __webpack_public_path__ + "static/media/logo_np_top.9319f7cf.png";